import { render, staticRenderFns } from "./packagelist.vue?vue&type=template&id=a4291e16&"
import script from "./packagelist.js?vue&type=script&lang=js&"
export * from "./packagelist.js?vue&type=script&lang=js&"
import style0 from "./packagelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports